import React from 'react'
import FileUploadCard from '../../fileUploadCard'
import DialogFooter from '../../dialogFooter'
import { Dialog } from 'primereact/dialog'
import Card from '../../card'
import * as popUp from '../../toastr'
import ConstantsUtil from '../../../context/constantsUtil'
import HandleErrorService from '../../../app/service/handleErrorService'
import ProgressBarComponent from '../../progress/progressBar'
import FolhaDePagamentoService from '../../../app/service/contasAPagar/folhaDePagamentoService'


class ImportacaoFolhaDePagamentoDialog extends React.Component {

    constructor(){
        super()
        this.folhaDePagamentoService = new FolhaDePagamentoService()
    }

    state = {
        completedUpload: false,

        inProgressToSave:  false,
        progressKey: null,

        loading: false,
    }

    onFinishUpload = (progressKey) => {
        // this.hideDialog()
    }

    hideDialog = () => {
        this.setState({completedUpload: false})
        this.setState({inProgressToSave: false})
        this.props.hideDialog()
    }


    render(){

        const renderUpload = () => {
            if(!this.state.completedUpload){
                return (
                    <>
                        <FileUploadCard
                            uploadInProgress = {this.setIfIsInProgress}
                            accept=".xlsx"
                            uploadDescription={ConstantsUtil.importacaoFolhaDePagamentoDescricao}
                            onFinish={this.onFinishUpload}
                        />
                    </>
                )            
            }
        }

        const uploadDialogFooter = (
            <DialogFooter save={this.callSave} hideDialog={this.hideDialog} disabled={!this.state.completedUpload || this.state.inProgressToSave} />
        )

        const renderProgressBar = () => {
            if(this.state.completedUpload && this.state.inProgressToSave){
                return(
                    <>
                        <ProgressBarComponent
                            progressKey={this.state.progressKey}
                            endProgress={this.endSaveLancamentos}
                            successNoticeMessage="Importação concluída com sucesso!"
                            failNoticeMessage="Falha no reprocessamento. Tente novamente."
                        />
                    </>
                )
            }            
        }


        return (
            <>
                <Dialog
                    visible={this.props.visible}
                    style={{ maxHeight: '95vh', width: '85vw'}}
                    modal
                    className="p-fluid"
                    baseZIndex={-1}
                    footer={uploadDialogFooter}
                    onHide={this.hideDialog}>
                    <div className="p-field">
                    <Card
                        title = {"Importação de Folha de Pagamento em XLSX (Excel)"}
                    >
                        {renderUpload()}
                        {renderProgressBar()}
                    </Card>
                    </div>
    
                </Dialog>       
            </>
        )
    }

    
}

export default ImportacaoFolhaDePagamentoDialog